import { render, staticRenderFns } from "./travel_standards.vue?vue&type=template&id=2f881833&"
import script from "./travel_standards.vue?vue&type=script&lang=js&"
export * from "./travel_standards.vue?vue&type=script&lang=js&"
import style0 from "./travel_standards.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports